import { showConfigureActions } from "../../services";

export const showConfigureDispatcher  = dispatch =>({
    showConfigureComponent: (component)=>dispatch({type:showConfigureActions.SHOW, component}),
    leaveConfigurator:()=>dispatch({type:showConfigureActions.LEAVE}),
    stayConfigurator:()=>dispatch({type:showConfigureActions.STAY}),
    hideConfigure: ()=>dispatch({type:showConfigureActions.HIDE}),
    updateConfigure: (update)=>dispatch({type:showConfigureActions.UPDATE, update} )
})